import React from "react";
import {
  Center,
  FormControl,
  Select as SelectBase,
  WarningOutlineIcon,
  CheckIcon,
  ChevronDownIcon,
} from "native-base";
import { getDir } from "../util";
interface DataProps {
  label: string;
  value: string;
}
const Select = ({
  data,
  errorMessage,
  label,
  isInvalid,
  isRequired,
  placeholder,
  value,
  onChangeText,
  containerStyle,
  style,
  props,
}: any) => {
  return (
    <Center style={containerStyle}>
      <FormControl isRequired={isRequired} isInvalid={isInvalid}>
        {label && (
          <FormControl.Label
            mb="1"
            _text={{
              fontSize: "14",
            }}
          >
            {label || ""}
          </FormControl.Label>
        )}
        <SelectBase
          selection={1} // for bug => Select element takes focus from input element on react native web on Safari browser
          selectedValue={value}
          onValueChange={onChangeText}
          accessibilityLabel={label || ""}
          placeholder={placeholder || ""}
          //   === Style ===
          bg="white"
          minWidth="80px"
          // h="40px"
          my="2"
          borderRadius="10px"
          style={[{ direction: getDir(), height: 40 }, style]}
          _selectedItem={{
            bg: "PRIMARY",
            borderRadius: "5px",
            _text: {
              color: "white",
            },
            endIcon: <CheckIcon size={5} />,
          }}
          dropdownIcon={<ChevronDownIcon size={3} mx="5px" />}
          {...props}
        >
          {data?.map((item: DataProps, index: number) => {
            return (
              <SelectBase.Item
                key={index}
                label={item.label}
                value={item.value}
              />
            );
          })}
        </SelectBase>
        {errorMessage !== "" && (
          <FormControl.ErrorMessage leftIcon={<WarningOutlineIcon size="xs" />}>
            {errorMessage}
          </FormControl.ErrorMessage>
        )}
      </FormControl>
    </Center>
  );
};

export default Select;
